// extracted by mini-css-extract-plugin
export default {"header":"SetConfigurationCalendars_header__lcP8Q","headerBg":"SetConfigurationCalendars_headerBg__rifRH","headerImg":"SetConfigurationCalendars_headerImg__D2qKT"};